import React from "react";

import Bounce from "./loaders/Bounce";

const ComponentLoader = () => {
	return <Bounce />;
};

export default ComponentLoader;
